// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl

const getNews = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};

export { getNews };
